import * as React from 'react';
import * as UserActions from '@services/user/user.actions';
import {connect} from 'react-redux';
import TranslateNew from "@translate/TranslateNew";
import {Redirect, RouteComponentProps, withRouter} from 'react-router-dom';
import {IUser, IUserOnboarding} from '@app-types/api/user.types';
import StepNotifications from '@components/onboarding/steps/StepNotifications/notifications.component';
import StepCalendarSync from '@components/onboarding/steps/StepCalendarSync/calendarSync.component';
import StepScheduleCreate from '@components/onboarding/steps/StepScheduleCreate/scheduleCreate.component';
import FullScreenCard from '@components/common/fullscreencard/FullScreenCard';
import CordovaContext from 'src/cordovaContext';
import VarannanVeckaLogo from '@components/svg/varannanvecka';
import {FamilyMemberType} from '@services/family/family.constants';
import StepSubscribe from '@components/onboarding/steps/StepSubscribe/subscribe.component';
import {Dialog} from "@material-ui/core";
import StepAddCoparent from "@components/onboarding/steps/StepAddCoparent/addCoparent.component";
import StepAddChild from "@components/onboarding/steps/StepAddChild/addChild.component";
import StepImportHolidays from "@components/onboarding/steps/StepImportHolidays/importHolidaysAI.component";
import StepCompleted from "@components/onboarding/steps/StepCompleted/completed.component";
import StepLoading from "@components/onboarding/steps/StepLoading/loading.component";
import { ISchedule } from '@app-types/websocket/schedule.types';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import SpecialofferComponent from '@components/onboarding/steps/StepSpecialOffer/specialoffer.component';
import { logFirebaseAnalyticsEvent } from '@services/firebase/firebaseAnalytics';
import { getSelectedFamilyResource } from '@services/user/user.utils';

const tn: TranslateNew = TranslateNew.getInstance();

export interface ISlide {
    step: number;
    slide: JSX.Element;
    sideElement: JSX.Element;
    skipIfNotPhone?: boolean;
    skipIfHaveSchedule?: boolean;
    skipIfNotHaveSchedule?: boolean;
    skipIfNotFirstParent?: boolean;
    skipIfNotParent?: boolean;
    skipIfHaveCoparent?: boolean;
    skipIfHaveChildren?: boolean;
    skipIfSharedScheduleExists?: boolean,
    skipAlways?:boolean,
    skipIfNotBoras?:boolean,
}

interface IProps extends RouteComponentProps {
    classes: any;
    language: string;
    iAmFirstParent: boolean;
    iAmParent: boolean;
    iHaveCoparent: boolean;
    iHaveChildren: boolean;
    iHaveSchedule: boolean;
    finishLoaded: boolean;
    isTogether:boolean
    thereIsASharedSchedule:boolean;
    onboarding: (data: IUserOnboarding) => void;
    setActiveStep: (newStep: number) => void;
    claimSpecialOffer: (data:{familyId:number, accountId:number, offer:string}) => void;
    activeStep: number;
    myFamilyId:number;
    user: IUser;
}

interface IState {
    onboardingSlides: ISlide[];
    history: number[];
    time: number;
    started: boolean;
    region: string;
}

class POnboardingContainer extends React.Component<IProps, IState> {
    private hasLoggedTutorialBegin = false;

    constructor(props: IProps) {
        super(props);

        this.nextStep = this.nextStep.bind(this);
        this.filterUnwantedslides = this.filterUnwantedslides.bind(this);

        const initialSteps: ISlide[] = [
            {
                step: 0,
                skipIfNotFirstParent: true,
                skipIfNotParent: true,
                skipIfHaveCoparent: true,
                slide: <StepAddCoparent
                    key={"addCoparent"}
                    progress={10}
                    nextStep={this.nextStep}
                />,
                sideElement: <VarannanVeckaLogo/>
            },
            {
                step: 1,
                skipIfNotFirstParent: true,
                skipIfNotParent: true,
                skipIfHaveChildren: true,
                slide: <StepAddChild
                    key={"addChild"}
                    progress={20}
                    nextStep={this.nextStep}
                />,
                sideElement: <VarannanVeckaLogo/>
            },
            {
                step: 2,
                skipIfNotPhone: true,
                slide: <StepNotifications
                    key={"notifications"}
                    progress={30}
                    nextStep={this.nextStep}
                />,
                sideElement: <VarannanVeckaLogo/>
            },
            {
                step: 3,
                skipIfNotParent: true,
                skipIfNotFirstParent:true,
                slide: <StepImportHolidays
                    key={"importHolidays"}
                    progress={40}
                    nextStep={this.nextStep}
                    setRegion={(region: string) => {this.setState({region});}}
                />,
                sideElement: <VarannanVeckaLogo/>
            },
            {
                skipIfHaveSchedule: true,
                skipIfNotParent: true,
                step: 4,
                slide: <StepScheduleCreate
                    key={"scheduleCreate"}
                    progress={60}
                    nextStep={this.nextStep}
                />,
                sideElement: <VarannanVeckaLogo/>
            },
            {
                skipIfNotParent: true,
                skipIfNotFirstParent:true,
                skipIfNotBoras:true,
                step: 5,
                slide: <SpecialofferComponent
                    key={"specialOffer"}
                    claimSpecialOffer={() => this.acceptOffer()}
                    progress={70}
                    nextStep={this.nextStep} 
                />,
                sideElement: <VarannanVeckaLogo/>
            },
            {
                step: 6,
                skipIfNotPhone: true,
                skipAlways: true, // just to not display this slide
                slide: <StepCalendarSync
                    key={"calendarSync"}
                    progress={80}
                    nextStep={this.nextStep}
                />,
                sideElement: <VarannanVeckaLogo/>
            },
            {
                step: 7,
                skipIfNotPhone: false,
                skipIfNotFirstParent: true,
                skipIfNotParent: true,
                slide: <StepSubscribe
                    key={"subscribe"}
                    progress={90}
                    nextStep={this.nextStep}
                />,
                sideElement: <VarannanVeckaLogo/>
            },
            {
                step: 8,
                slide: <StepCompleted
                    key={"completed"}
                    nextStep={() => {this.props.setActiveStep(9);}}
                />,
                sideElement: <VarannanVeckaLogo/>
            }
        ];

        this.state = {
            onboardingSlides: initialSteps,
            history: [],
            time: Date.now(),
            started: false,
            region: "",
        };
    }

    public componentDidMount() {
        if (this.props.finishLoaded && !this.state.started) {
            this.nextStep(this.props.activeStep || 0);
        }
        this.logTutorialBeginIfNeeded();
    }


    public componentDidUpdate(oldProps: IProps) {
        if (oldProps.user?.id !== this.props.user?.id) {
            this.logTutorialBeginIfNeeded();
        }
        if (this.props.finishLoaded && !this.state.started) {
            this.setState({started: true});
            this.nextStep(this.props.activeStep || 0);
            return;
        }
        if(oldProps.activeStep !== this.props.activeStep) {
            this.nextStep(this.props.activeStep || 0);
        }
    }

    public render() {
        if (this.props.activeStep >= 0 && this.props.activeStep <= (this.state.onboardingSlides.length - 1)) {
            return (
                <Dialog
                    fullScreen={true}
                    open={true}
                    scroll="body"
                    transitionDuration={0}
                >
                    {!this.state.started && (
                        <FullScreenCard sideElement={<VarannanVeckaLogo/>}>
                            <StepLoading key="loading"/>
                        </FullScreenCard>
                    )}
                    <FullScreenCard sideElement={this.state.onboardingSlides[this.props.activeStep].sideElement}>
                        {this.state.onboardingSlides[this.props.activeStep].slide}
                    </FullScreenCard>
                </Dialog>
            );
        } else {
            return <Redirect to='/app/calendar/:calendarId/:suggestionId'/>;
        }
    }

    private acceptOffer() {
        if (this.state.region.trim().toLowerCase().startsWith("borå")) {
            this.props.claimSpecialOffer({familyId:this.props.myFamilyId, accountId:this.props.user.id, offer:"boras"});
        } else if (this.state.region.trim().toLowerCase().startsWith("orsa")) {
            this.props.claimSpecialOffer({familyId:this.props.myFamilyId, accountId:this.props.user.id, offer:"orsa"});
        } else if (this.state.region.trim().toLowerCase().startsWith("eskil")) {
            this.props.claimSpecialOffer({familyId:this.props.myFamilyId, accountId:this.props.user.id, offer:"etuna"});
        }
    }

    private nextStep(customStep?: number) {
        const oldStep = this.state.history.slice(-1).pop() || 0;
        const history = this.state.history.slice();
        let newStep: number | undefined = customStep !== undefined ? customStep : oldStep + 1;
        newStep = this.filterUnwantedslides(newStep);
        if (newStep !== undefined) {
            history.push(newStep);
            this.setState({history});
            this.props.setActiveStep(newStep);

            const isCordovaApp = this.context;
            if (isCordovaApp && newStep === 9) {
                void logFirebaseAnalyticsEvent("tutorial_complete", {}, this.props.user?.id);
            }
        } else {
            this.props.setActiveStep(history.slice(-1).pop() || 0);
        }

        this.props.onboarding({time: this.state.time, data: JSON.stringify(history)});
        // this line requires mui dialog to work correctly
        const element = document.querySelector('[role="dialog"]');
        if (element) {
            element.scrollTo(0, 0);
        }
        return;
    }

    private logTutorialBeginIfNeeded() {
        if (!this.context || this.hasLoggedTutorialBegin || !this.props.user?.id) {
            return;
        }

        this.hasLoggedTutorialBegin = true;
        void logFirebaseAnalyticsEvent("tutorial_begin", {}, this.props.user.id);
    }

    private filterUnwantedslides(step: number): number | undefined {
        const {onboardingSlides: slides} = this.state;
        const newSlide = slides.find(slide => slide.step === step);
        const isCordovaApp = this.context;

        if(step > (slides.length - 1)) {
            return step;
        }
        if (newSlide === undefined || this.state.onboardingSlides.length === 0 ) {
            return undefined;
        }
        if (slides[step].skipAlways) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfHaveSchedule && (this.props.iHaveSchedule || this.props.isTogether)) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfNotHaveSchedule && !this.props.iHaveSchedule) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfSharedScheduleExists && this.props.thereIsASharedSchedule) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfNotFirstParent && !this.props.iAmFirstParent) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfNotParent && !this.props.iAmParent) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfHaveCoparent && this.props.iHaveCoparent) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfHaveChildren && this.props.iHaveChildren) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfNotPhone && !isCordovaApp) {
            return this.filterUnwantedslides(step + 1);
        }
        if (slides[step].skipIfNotBoras && (!this.state.region.trim().toLowerCase().startsWith("borå") 
            && !this.state.region.trim().toLowerCase().startsWith("orsa")
            && !this.state.region.trim().toLowerCase().startsWith("eskil"))) {
            return this.filterUnwantedslides(step + 1);
        }
        return step;
    }
}

POnboardingContainer.contextType = CordovaContext;

function mapStateToProps(state: any) {
    let finishLoaded = false;
    finishLoaded = (state.logs.logEntries && state.logs.logEntries.length > 0);
    const userId = state.user.session.data.id;
    let iAmFirstParent = true;
    let iAmParent = false;
    let iHaveCoparent = false;
    let iHaveChildren = false;
    let thereIsASharedSchedule = false;

    if (state.schedule.schedules && (state.schedule.schedules.length > 0)) {
        const schedules:ISchedule[] = state.schedule.schedules;
        for (const schedule of schedules) {
            if (schedule.status === SCHEDULE_TYPES.SHARED || schedule.status === SCHEDULE_TYPES.ACTIVE) {
                thereIsASharedSchedule = true;
            }
        }
    }

    for (const mem of state.family.family) {
        if (mem.id !== userId && mem.role === FamilyMemberType.PARENT && mem.lastOnline && mem.lastOnline > 0) {
            iAmFirstParent = false;
        }
        if (mem.id === userId && mem.role === FamilyMemberType.PARENT) {
            iAmParent = true;
        }
        if (mem.id !== userId && mem.role === FamilyMemberType.PARENT) {
            iHaveCoparent = true;
        }
        if (mem.id !== userId && mem.role === FamilyMemberType.CHILD) {
            iHaveChildren = true;
        }
    }
    let myFamilyId = 0;
    const myFam = getSelectedFamilyResource(state.user?.session);
    if (myFam?.id !== undefined) {
        myFamilyId = myFam.id;
    }

      let isTogether:boolean = false;
    
      if (myFam !== undefined) {
          isTogether = myFam.familyType === "TOGETHER";
          // console.log(myFam.familyType);
      }

    return {
        activeStep: (state.user.onboarding && state.user.onboarding.activeStep)? state.user.onboarding.activeStep : 0,
        language: state.user.language,
        iAmFirstParent,
        finishLoaded,
        iAmParent,
        iHaveCoparent,
        iHaveChildren,
        iHaveSchedule: (state.schedule.schedules ? (state.schedule.schedules.length > 0) : false),
        thereIsASharedSchedule,
        myFamilyId,
        isTogether,
        user: state.user.session.data,
    };
}

const mapDispatchToProps = {
    onboarding: UserActions.onboarding,
    setActiveStep: UserActions.onboardingSetActiveStep,
    claimSpecialOffer: UserActions.claimSpecialOffer,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(POnboardingContainer));



// WEBPACK FOOTER //
// ./src/containers/onboarding/onboarding.container.tsx